import React from "react";
import CouponEdit from "../../../components/admin/coupons/coupon-edit";
import AdminTemplate from "../../../templates/admin-template";

const AdminCouponEditPage = () => {
  return <AdminTemplate><CouponEdit/></AdminTemplate>;
};

export default AdminCouponEditPage;
